import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material"
import { Button } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { removeSelectedPool, setSelectedPool } from "../../../redux/slices/toggleControlSlices"

export default function PoolNameButton({ pool, index }) {
    const selectedPools = useSelector((state) => state.toggleControl.selectedPool)
    const dispatch = useDispatch()

    return(
        <Button
            key={index}
            startIcon={
                selectedPools.includes(JSON.stringify(pool)) ? (
                    <RadioButtonChecked sx={{ color: "#118EA0" }} />
                ) : (
                    <RadioButtonUnchecked />
                )
            }
            sx={{
                color: "#fff",
                backgroundColor: "transparent !important",
                textTransform: "none",
                maxHeight: "32px",
                minHeight: "32px",
                justifyContent: "left",
                fontFamily: "Averta",
                "&:hover" : {color: "#118EA0"}
              }}
              onClick={() => {
                if (selectedPools.includes(JSON.stringify(pool))) {
                    dispatch(removeSelectedPool(JSON.stringify(pool)))
                } else {
                    dispatch(setSelectedPool(JSON.stringify(pool)))
                }
              }}
        >
            {pool.pool_name}
        </Button>
    )
}